<template>
  <div>
    <div class="page-header">
      <img
        :src="page.image"
        :alt="page.title ?? ''"
        class="background-image"
        fetchpriority="high"
      />
      <div class="layer" />
      <h1>
        <span v-if="page.titleSmall">{{ page.titleSmall }}</span>
        {{ page.titleBig }}
      </h1>
      <p
        v-if="page.description && !large"
        class="subtitle"
        :class="{ large }"
      >
        {{ page.description }}
      </p>
      <p
        v-if="page.description && large"
        class="subtitle large"
        v-html="page.description"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    page: {
      title?: string
      titleSmall?: string
      titleBig?: string
      description?: string
      image?: string
    }
    large?: boolean
  }>(),
  {
    large: false,
  },
)
</script>

<style lang="scss" scoped>
.page-header {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90vh;
  max-height: 73rem;

  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    pointer-events: none;
  }

  .layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($black, 0.44);
  }

  h1 {
    z-index: 1;
    color: $white;
    font-family: 'SST Condensed';
    font-size: 8rem;
    line-height: 7rem;
    letter-spacing: 1.6rem;
    text-align: center;
    text-transform: uppercase;

    span {
      display: block;
      font-size: 4rem;
      font-weight: 400;
      letter-spacing: 0.8rem;
    }
  }

  .subtitle {
    z-index: 1;
    max-width: 37.4rem;
    margin-top: 1.6rem;
    color: $white;
    font-size: 1.2rem;
    line-height: 1.6rem;
    text-align: center;

    &.large {
      max-width: 62.4rem;
    }

    @media screen and (min-width: 1023px) {
      max-width: 62.4rem;
    }
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 0;
    height: 0;
    border-width: 0 0 5rem 100vw;
    border-style: solid;
    border-color: transparent transparent $white transparent;
  }
}

@media screen and (max-width: 700px) {
  .page-header {
    h1 {
      font-size: 6.1rem;
      line-height: 6.4rem;
      letter-spacing: 1rem;

      span {
        font-size: 3.1rem;
        font-weight: 400;
        letter-spacing: 0.5rem;
      }
    }

    .subtitle {
      max-width: calc(100% - 5rem);

      &.large {
        max-width: calc(100% - 5rem);
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .page-header {
    h1 {
      font-size: 4.1rem;
      line-height: 4.4rem;
      letter-spacing: 0.8rem;

      span {
        font-size: 2.1rem;
        font-weight: 400;
        letter-spacing: 0.4rem;
      }
    }
  }
}
</style>
